import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";

import * as IconSVG from "../../assets/iconsSVG";
import NavCommon from "../../components/@navHeader";
import warn from "../../constants/toast";
import axiosLead from "../../services/lead";
import * as Styles from "./styles";

interface IVideosAcademia {
  arquivo: string;
  duracao: string;
  id: string;
  idsRegionais: string[];
  tamanho: string;
  titulo: string;
  url: string;
}

const VideoItemSkelleton = () => {
  const renderSkeletons = () => {
    const skeletons = [];

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < 20; i++) {
      // @ts-ignore
      skeletons.push(<Styles.VideoItemSkelleton key={i} />);
    }

    return skeletons;
  };

  return <>{renderSkeletons()}</>;
};

const Academia = () => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [videoParams, setVideoParams] = useState<any>({});
  const [videosAcademia, setVideosAcademia] = useState<any>([]);

  const requestVideosAcademia = async () => {
    setLoading(true);
    try {
      const response = await axiosLead.GetVideosAcademia();
      setVideosAcademia(response?.data?.data);
    } catch (error: any) {
      warn.wargingError(
        `${
          error?.response?.data?.notifications?.map(
            (item: any) => `${item.message}\n`
          ) || "Erro ao listar videos"
        }`
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    requestVideosAcademia();
    setVideoParams({
      titulo: videosAcademia?.[0]?.titulo,
      url: videosAcademia?.[0]?.url,
    });
  }, []);

  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: "", name: "Academia Sell.it" }]}
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => history.push("/")}
      />
      <Styles.Content>
        <Styles.Title>Academia Sell.it</Styles.Title>
        <Styles.Container>
          <Styles.List>
            <Styles.SpaceY space={16} />
            {loading ? (
              <>
                <VideoItemSkelleton />
              </>
            ) : (
              <>
                {videosAcademia?.map((item: IVideosAcademia) => (
                  <>
                    <Styles.VideoItem
                      key={item?.url}
                      onClick={() =>
                        setVideoParams({
                          title: item?.titulo,
                          url: item?.url,
                        })
                      }
                    >
                      <IconSVG.PlayIcon />
                      <p>{item?.titulo}</p>
                    </Styles.VideoItem>
                  </>
                ))}
              </>
            )}

            <Styles.SpaceY space={16} />
          </Styles.List>
          <Styles.VideoContainer>
            <Styles.VideoTitle>
              <p>{videoParams?.title}</p>
            </Styles.VideoTitle>
            <Styles.VideoPlayer>
              <ReactPlayer
                controls
                width="100%"
                height="100%"
                url={videoParams?.url}
              />
            </Styles.VideoPlayer>
          </Styles.VideoContainer>
        </Styles.Container>
      </Styles.Content>
    </>
  );
};

export default Academia;
